import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { integrationsApi } from "../api/integrations.api";

import useToast from "@/lib/hooks/useToast";

export function useGenerateApiKey() {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      integrationName,
      tenantId,
    }: {
      integrationName: string;
      tenantId: string;
    }) => {
      return await integrationsApi.generateIntegrationApiKey(integrationName, tenantId);
    },
    onError: (err: unknown) => {
      const error = err as {
        response?: { data?: { title?: string; detail?: string; error?: string; message?: string } };
        message?: string;
      };
      const errorData = error?.response?.data;
      const errorMessage =
        errorData?.detail ||
        errorData?.message ||
        error?.message ||
        t("integrations.modules.apiKey.generateFailed", "Failed to generate API key");
      showToast(errorMessage, "error");
    },
    onSuccess: () => {
      showToast(
        t("integrations.modules.apiKey.generated", "API key generated successfully"),
        "success"
      );
    },
    onSettled: (_data, _err, variables) => {
      // Refresh the key list (a key was added).
      queryClient.invalidateQueries({
        queryKey: ["integrationApiKey", variables.integrationName, variables.tenantId],
      });
    },
  });
}
